/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TimePointListEntry } from './timePointListEntry';


export interface HistInfo { 
    erstellzeitpunkt?: Date;
    histEnum?: HistInfo.HistEnumEnum;
    vonTimePoint?: TimePointListEntry;
    bisTimePoint?: TimePointListEntry;
}
export namespace HistInfo {
    export type HistEnumEnum = 'ILLEGALER_ZUSTAND' | 'ERSTERFASSUNG' | 'VON_RECHTGUELTIG_BIS_NULL' | 'VON_RECHTGUELTIG_BIS_AKTUELL' | 'VON_RECHTGUELTIG_BIS_VERKNUEPFT' | 'VON_RECHTGUELTIG_BIS_VORGAENGIG' | 'VON_RECHTGUELTIG_BIS_RECHTSGUELTIG' | 'VON_VORGAENGIG_BIS_NULL' | 'VON_VORGAENGIG_BIS_AKTUELL' | 'VON_VORGAENGIG_BIS_VERKNUPEFT' | 'VON_VORGAENGIG_BIS_VORGAENGER' | 'VON_VERKNUEPFT_BIS_NULL' | 'VON_VERKNUEPFT_BIS_AKTUELL' | 'VON_VERKNUEPFT_BIS_VERKNUEPFT' | 'VON_AKTUELL_BIS_NULL' | 'VON_AKTUELL_BIS_AKTUELL';
    export const HistEnumEnum = {
        ILLEGALERZUSTAND: 'ILLEGALER_ZUSTAND' as HistEnumEnum,
        ERSTERFASSUNG: 'ERSTERFASSUNG' as HistEnumEnum,
        VONRECHTGUELTIGBISNULL: 'VON_RECHTGUELTIG_BIS_NULL' as HistEnumEnum,
        VONRECHTGUELTIGBISAKTUELL: 'VON_RECHTGUELTIG_BIS_AKTUELL' as HistEnumEnum,
        VONRECHTGUELTIGBISVERKNUEPFT: 'VON_RECHTGUELTIG_BIS_VERKNUEPFT' as HistEnumEnum,
        VONRECHTGUELTIGBISVORGAENGIG: 'VON_RECHTGUELTIG_BIS_VORGAENGIG' as HistEnumEnum,
        VONRECHTGUELTIGBISRECHTSGUELTIG: 'VON_RECHTGUELTIG_BIS_RECHTSGUELTIG' as HistEnumEnum,
        VONVORGAENGIGBISNULL: 'VON_VORGAENGIG_BIS_NULL' as HistEnumEnum,
        VONVORGAENGIGBISAKTUELL: 'VON_VORGAENGIG_BIS_AKTUELL' as HistEnumEnum,
        VONVORGAENGIGBISVERKNUPEFT: 'VON_VORGAENGIG_BIS_VERKNUPEFT' as HistEnumEnum,
        VONVORGAENGIGBISVORGAENGER: 'VON_VORGAENGIG_BIS_VORGAENGER' as HistEnumEnum,
        VONVERKNUEPFTBISNULL: 'VON_VERKNUEPFT_BIS_NULL' as HistEnumEnum,
        VONVERKNUEPFTBISAKTUELL: 'VON_VERKNUEPFT_BIS_AKTUELL' as HistEnumEnum,
        VONVERKNUEPFTBISVERKNUEPFT: 'VON_VERKNUEPFT_BIS_VERKNUEPFT' as HistEnumEnum,
        VONAKTUELLBISNULL: 'VON_AKTUELL_BIS_NULL' as HistEnumEnum,
        VONAKTUELLBISAKTUELL: 'VON_AKTUELL_BIS_AKTUELL' as HistEnumEnum
    };
}


